const translations = {
  generateTemplate: 'Generate import template',
  exportOf: 'Export of {{name}}',
  generate: 'Generate',
  all: 'All',
  customize: 'Customize',
  exportPdf: 'Export PDF',
  exportExcel: 'Export Excel',
  columns: 'Columns',
  pdfInfo: 'In PDF format, a summary of each activity will be sent by email, ready for viewing and printing.',
  creationDate: 'Creation date',
  schedulingDate: 'Scheduling date',
  period: 'Period',
  includeReplies: 'Include replies',
  includeRepliesTooltip: 'By checking this option, all activity columns will be included.',
  checklist: 'Checklist',
  formatBlockQuestions: 'Format block questions',
  formatBlockQuestionsTooltip:
    'Each answer line will be a line in the exported file \n with the other values repeated.',
  type: 'Type',
  name: 'Name',
  email: 'Email',
  levels: 'Levels',
  place: 'Place',
  number: 'Number',
  placeOrPerson: 'Place/Person',
  userField: 'User',
  startDate: 'Start date',
  endDate: 'End date',
  replies: 'Replies',
  exportingSelected: 'Exporting {{count}} selected activity',
  exportingSelected_plural: 'Exporting {{count}} selected activities',
  exportHistory: 'Export History',
  of: 'of',
  date: 'Date',
  entity: 'Entity',
  user: 'User',
  download: 'Download',
  error: 'Error'
}

export default translations
